import { ProgrammeListModel } from './programme.model';

export interface ProgrammeCardData {
  slug: string;
  image: string;
  venue: string;
  title: string;
  category: string;
  duration: string;
}

export function toProgrammeCard(p: ProgrammeListModel): ProgrammeCardData {
  return {
    slug: p.slug ?? '',
    image: p.cover_image?.thumb || p.cover_image?.ori || p.images?.[0]?.thumb || '',
    venue: p.venue?.[0]?.place_name || p.location_text || '',
    title: p.title,
    category: p.main_category?.category || p.categories?.[0]?.category || '',
    duration: durationLabel(p),
  };
}

function durationLabel(p: ProgrammeListModel): string {
  const start = p.next_session_available?.start_datetime;
  const end = p.next_session_available?.end_datetime;
  if (!start || !end) return '';
  const hours = Math.round((new Date(end).getTime() - new Date(start).getTime()) / 3_600_000);
  if (hours <= 0) return '';
  return hours === 1 ? '1 hour' : `${hours} hours`;
}
